import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { contextConnect, useContextSystem } from '@wp-g2/context';
import { mergeRefs } from '@wp-g2/utils';
import React from 'react';
import { TooltipReference, useTooltipState } from 'reakit';
import { TooltipContext } from './Tooltip.Context';
import TooltipContent from './TooltipContent';

function Tooltip(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Tooltip'),
      _useContextSystem$ani = _useContextSystem.animated,
      animated = _useContextSystem$ani === void 0 ? true : _useContextSystem$ani,
      _useContextSystem$ani2 = _useContextSystem.animationDuration,
      animationDuration = _useContextSystem$ani2 === void 0 ? 160 : _useContextSystem$ani2,
      baseId = _useContextSystem.baseId,
      children = _useContextSystem.children,
      content = _useContextSystem.content,
      _useContextSystem$foc = _useContextSystem.focusable,
      focusable = _useContextSystem$foc === void 0 ? true : _useContextSystem$foc,
      _useContextSystem$gut = _useContextSystem.gutter,
      gutter = _useContextSystem$gut === void 0 ? 4 : _useContextSystem$gut,
      id = _useContextSystem.id,
      _useContextSystem$mod = _useContextSystem.modal,
      modal = _useContextSystem$mod === void 0 ? true : _useContextSystem$mod,
      placement = _useContextSystem.placement,
      _useContextSystem$vis = _useContextSystem.visible,
      visible = _useContextSystem$vis === void 0 ? false : _useContextSystem$vis,
      otherProps = _objectWithoutProperties(_useContextSystem, ["animated", "animationDuration", "baseId", "children", "content", "focusable", "gutter", "id", "modal", "placement", "visible"]);

  var tooltip = useTooltipState(_objectSpread({
    animated: animated ? animationDuration : undefined,
    baseId: baseId || id,
    gutter: gutter,
    placement: placement,
    unstable_portal: modal,
    visible: visible
  }, otherProps));
  var contextProps = React.useMemo(function () {
    return {
      tooltip: tooltip
    };
  }, [tooltip]);
  var childRef = children == null ? void 0 : children.ref;
  var refs = React.useMemo(function () {
    return mergeRefs([forwardedRef, childRef]);
  }, [childRef, forwardedRef]);
  return /*#__PURE__*/React.createElement(TooltipContext.Provider, {
    value: contextProps
  }, content && /*#__PURE__*/React.createElement(TooltipContent, null, content), children && /*#__PURE__*/React.createElement(TooltipReference, Object.assign({}, tooltip, children.props, {
    ref: refs
  }), function (referenceProps) {
    if (!focusable) {
      referenceProps.tabIndex = undefined;
    }

    return /*#__PURE__*/React.cloneElement(children, referenceProps);
  }));
}

export default contextConnect(Tooltip, 'Tooltip');